export default "__VITE_ASSET__B1CqL9UC__"